export default {
    REQUIRED: "val_field_required",
    PASSWORD_DO_NOT_MATCH: "val_password_dont_match",
    INVALID_DATE: "val_invalid_date",
    ONLY_NUMBERS: "validations:only_numbers",
    MAX_CHARACTERS: "validations:max_characters",
    MIN_CHARACTERS: "validations:min_characters"
}